import { Response } from "./response";

export function manageAttachments(response: Response): void  {
    if (response.attachments == null || response.attachments.length == 0) {
        return;
    }
    for (const attachment of response.attachments) {
        if (attachment.disposition === "attachment") {
            const filename = (attachment.filename != null ? attachment.filename : "file.download");

            // The actual download
            // const blob = new Blob([atob(attachment.data)], { type: attachment.contentType });
            const blob = b64toBlob(attachment.data, attachment.contentType);
            const link = document.createElement("a");
            link.href = window.URL.createObjectURL(blob);
            link.download = filename;

            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        } else {
            const byteCharacters = atob(attachment.data);
            const byteNumbers = new Array(byteCharacters.length);
            for (let i = 0; i < byteCharacters.length; i++) {
                byteNumbers[i] = byteCharacters.charCodeAt(i);
            }
            const byteArray = new Uint8Array(byteNumbers);
            const file = new Blob([byteArray], { type: attachment.contentType + ';base64' });
            const fileURL = URL.createObjectURL(file);
            window.open(fileURL, "_blank");
        }
    }
}

const b64toBlob = (b64Data, contentType = '', sliceSize = 512) => {
    const byteCharacters = atob(b64Data);
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
        const slice = byteCharacters.slice(offset, offset + sliceSize);

        const byteNumbers = new Array(slice.length);
        for (let i = 0; i < slice.length; i++) {
            byteNumbers[i] = slice.charCodeAt(i);
        }

        const byteArray = new Uint8Array(byteNumbers);
        byteArrays.push(byteArray);
    }

    const blob = new Blob(byteArrays, { type: contentType });
    return blob;
}



export function downloadFile(response: Buffer, jqXHR, ct: string) {

    // Try to find out the filename from the content disposition `filename` value
    const disposition = jqXHR.getResponseHeader("Content-Disposition");
    const matches = /"([^"]*)"/.exec(disposition);
    const filename = (matches != null && matches[1] ? matches[1] : "file.download");

    // The actual download
    const blob = new Blob([response], { type: ct });
    const link = document.createElement("a");
    link.href = window.URL.createObjectURL(blob);
    link.download = filename;

    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
}
